export const STORAGE_KEY_NEXT_LOAD_NOTIFICATION =
  'accountNext_nextLoadNotification'
